import * as R from 'remeda';
import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild, PipeTransform, Pipe } from '@angular/core';
import { WorkFlowListData, ListConfig } from './workflow.datasource';
import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';
import { Input } from '@angular/core';
import {Cf2MaterialModule} from "@modules/cf2-material/cf2-material.module";
import { MatSort } from '@angular/material/sort';
import { TaskModel } from '@api/models';
import { Router } from '@angular/router';
import { filter, pluck } from 'rxjs/operators'; 
import {TranslocoDirective, TranslocoService} from '@jsverse/transloco';
import {MatTable, MatTableDataSource} from "@angular/material/table";
import {DatePipe, NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'cf2-expenditure-workflows-list',
  templateUrl: './expenditure-workflows-list.component.html',
  styleUrls: ['./expenditure-workflows-list.component.scss'],
  imports: [
    Cf2MaterialModule,
    TranslocoDirective,
    DatePipe,
    NgForOf
  ],
})
export class ExpenditureWorkflowsListComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input() data: TaskModel[];
  @Input() filteredData: TaskModel[];
  @Input() isReady = false;

  @Input() customColmns: ListConfig;

  @Output() selectedTask = new EventEmitter<TaskModel>();

  dataSource = new MatTableDataSource<any>();
  columnConfig: ListConfig[];
  lockIcon = faLock;
  lockOpenIcon = faLockOpen;

  columns: any;
  sortColumn: string;
  sortDirection: boolean;

  constructor(private translocoService: TranslocoService) {
    const tableSetup = new WorkFlowListData(translocoService);
    this.columnConfig = tableSetup.config;
    this.columns = this.columnConfig.map((column) => column.key);
  }

  ngOnInit(): void {
    console.log('got to exp lists');
  }

  /*return true if date string greater than curr date */
  ltCurrDate(dateStr: string) {
    const currDate: Date = new Date();
    const testDate: Date = new Date(Date.parse(dateStr));
    return testDate.getTime() < currDate.getTime();
  }

  ngAfterViewInit() {
    // this.sort.sortChange.subscribe((obs) => {
    //   this.sortData(obs.active, obs.direction === 'asc');
    // });
  }

  public refNavigate(task: TaskModel) {
    this.selectedTask.emit(task);
  }
  sortData(column: string, asc: boolean): void {
    const data = this.data;
    const uniqVals = R.uniq(data.map((vals) => vals[column]));

    // avoid re-sorting a column that has one value.
    // TODO: move this out to a sorted value
    const nullChecked = data.map((itm) => ({
      ...itm,
      [column]: itm[column] == null ? '' : itm[column],
    }));

    if (column === 'expenditureDateFormatted') {
      const sorted = this.sortResults('expenditureDate', nullChecked, asc);
      this.sortDirection = asc;
      this.sortColumn = column;
      this.dataSource.data = uniqVals.length <= 1 ? data : sorted;
    } else {
      const sorted = this.sortResults(column, nullChecked, asc);
      this.sortColumn = column;
      this.sortDirection = asc;
      this.dataSource.data = uniqVals.length <= 1 ? data : sorted;
    }
  }

  sortResults(column: string, data: any[], isAsc = true): any[] {
    return R.sort(data, (a, b) => this.compare(a[column], b[column], isAsc));
  }

  compare(a, b, isAsc): any {
    if (!a) return -1;
    a = typeof a === 'string' ? a.toLowerCase() : a;
    b = typeof b === 'string' ? b.toLowerCase() : b;
    return (a.length < 1 ? -1 : a <= b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  viewExpenditure(data: TaskModel) {
    this.selectedTask.emit(data);
  }

  async updateSearch(filterStr: string): Promise<void> {
    const filter = filterStr.toLowerCase();
    const data = this.data;
    const columns = this.columns;
    const filtered = data.filter((row) => {
      const picked = R.pick(row, columns);
      const mapped = R.toPairs(picked).map((val) => val[1]);
      const some = mapped.some((val: string) => {
        if (typeof val === 'string') {
          const test = val.toLowerCase().includes(filter);
          return test;
        } else return val === filter;
      });
      return some;
    });
    this.dataSource.data = filtered;
  }
}
